import React from 'react';
import DialogContent from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogContent';

import PayWallBannerDescription from 'components/PayWall/PayWallBannerDescription';
import PayWallPlanDescription from 'components/PayWall/PayWallPlanDescription';
import { PayWallGroupIncrementalFeatures, PayWallPlan } from 'components/PayWall/Redux/Reducer.type';
import { useTrackEventsService } from 'components/Services/Analytics/useTrackEventsService';

import { PAY_WALL_VERSION, useDialogContentStyles } from './PayWallDialog';

type Props = {
  planGroups: PayWallGroupIncrementalFeatures[];
  required: string;
  planSelected: (plan: PayWallPlan) => void;
};

export default function PayWallPlanSelectionContent(props: Props) {
  const { trackButtonClicked } = useTrackEventsService();

  const { planGroups, required, planSelected } = props;

  const dialogContentClasses = useDialogContentStyles({ isLoading: false });

  return (
    <DialogContent dividers={false} classes={dialogContentClasses}>
      <PayWallBannerDescription />
      <PayWallPlanDescription
        planGroups={planGroups}
        required={required}
        planSelected={(planDetail) => {
          trackButtonClicked({ buttonName: 'plan selected', payWallVersion: PAY_WALL_VERSION });
          planSelected(planDetail);
        }}
      />
    </DialogContent>
  );
}
